import React from 'react'
import { useEffect } from 'react'
import { BottomSheet } from 'react-spring-bottom-sheet'

// import 'react-spring-bottom-sheet/dist/style.css'

import './rbs.css'






export default function OpenBottomSheet(props) {



    // const content =  <h1 className='text-4xl text-white'>hi</h1>

  // const [open, setOpen] = useState(false);
  // useEffect(() => {
   
  //   console.log(props.openPopup)

  // }, [props.openPopup])

  // useEffect(() => {

  //   if(props.openPopup === true) {
  //     setOpen(true)
  //   }
  // }, [props.openPopup])


  const onDismiss = () => {
    props.setOpenPopup(false)

    
  }

  return (
    <div>

      <BottomSheet
          open={props.openPopup}
          onDismiss={onDismiss}
        //   snapPoints={({ minHeight, maxHeight }) => ["800px", "100px"]}
        snapPoints={({ minHeight}) => [330]}
        skipInitialTransition={true}
        
        
        >
            {props.sheetContent}
           
        </BottomSheet>
    </div>
  )
}
